// extracted by mini-css-extract-plugin
module.exports = {"customPagination":"HotelGallerySwiper_customPagination__FFoIS"};